import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isAuthenticated, children }) => {
  // If the user is not authenticated, redirect them to the home page
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // If authenticated, render the requested component
  return children;
};

export default ProtectedRoute;
